module.exports = __webpack_public_path__ + "img/odonto_cura_singolo.4d4408bb.jpg";